import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row, DropdownButton, MenuItem, HelpBlock } from 'react-bootstrap';
import { Input, FormActions, DateTimeInput, Select } from '../../common/components/formControls';
import TermsDropdownList from '../terms/DropdownList';
import CentersDropdownList from '../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import utils from '../../common/services/utils';
import { PaymentHistoryMode } from './utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onSubmit, onReset, initialize, loading, paymentTypes, paymentStatusTypes, paymentMethods, mode, enableManualInstalment,
	isSubscriptionComplianceEnabled, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	const menuItemInnerStyle = { display: 'block', padding: '10px 20px' };

	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Field name='parent' component={Input} type='text' label={t('PaymentHistory_Parent')} />
						</Col>
						<Col sm={6}>
							<Field name='child' component={Input} type='text' label={t('PaymentHistory_Child')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='id' component={Input} type='text' label={t('PaymentHistory_Id')} />
						</Col>
						<Col sm={6}>
							<TermsDropdownList render='field' name='termId' label={t('PaymentHistory_Term')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' label={t('PaymentHistory_Center')} />
						</Col>
						<Col sm={6}>
							<Select name='status' label={t('PaymentHistory_Status')} data={paymentStatusTypes} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='city' component={Input} type='text' label={t('PaymentHistory_City')} />
						</Col>
						<Col sm={3}>
							<Field name='paymentDateFrom' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} label={t('PaymentHistory_PaymentDate')} placeholder={t('Common_From')} />
						</Col>
						<Col sm={3}>
							<Field name='paymentDateTo' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Select name='paymentType' label={t('PaymentHistory_PaymentType')} data={paymentTypes} />
						</Col>
						<Col sm={6}>
							<Select name='paymentMethodId' label={t('PaymentHistory_PaymentMethod')} data={paymentMethods} />
						</Col>
					</Row>
					{isSubscriptionComplianceEnabled && <Row>
						<Col sm={6}>
							<Field name='hasCancellationRequested' component={Input} componentClass='select' label={t('PaymentHistory_Subscription_CancellationRequested')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>
					</Row>}
					{mode === PaymentHistoryMode.INSTALMENTS && <div>
						<Row>
							<Col sm={6}>
								<Field name='isPaymentError' component={Input} componentClass='select' label={t('PaymentHistory_IsPaymentError')}>
									<option value={''}>{t('Common_All')}</option>
									<option value={true}>{t('Common_Yes')}</option>
									<option value={false}>{t('Common_No')}</option>
								</Field>
							</Col>
							<Col sm={6}>
								<Field name='isInactive' component={Input} componentClass='select' label={t('PaymentHistory_IsInactive')}>
									<option value={''}>{t('Common_All')}</option>
									<option value={true}>{t('Common_Yes')}</option>
									<option value={false}>{t('Common_No')}</option>
								</Field>
							</Col>
						</Row>
						<Row>
							<Col sm={6}>
								<Field name='hasOutstandingAmount' component={Input} componentClass='select' label={t('PaymentHistory_HasOutstandingAmount')}>
									<option value={''}>{t('Common_All')}</option>
									<option value={true}>{t('Common_Yes')}</option>
									<option value={false}>{t('Common_No')}</option>
								</Field>
							</Col>
						</Row>
					</div>}
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<DropdownButton title={<span>{t('Common_Export')} <FontAwesomeIcon icon={faChevronDown} /></span>} noCaret disabled={loading} bsStyle='warning'>
							<MenuItem key='Excel' eventKey='Excel' onSelect={handleSubmit(values => onSubmit({ ...values }, 'Excel'))}>
								<span style={menuItemInnerStyle} >{t('Common_ExportToExcel')}</span>
							</MenuItem>
							{mode === PaymentHistoryMode.ALL && <MenuItem key='Xero' eventKey='Xero' onSelect={handleSubmit(values => onSubmit({ ...values }, 'Xero'))} >
								<span style={menuItemInnerStyle} >{t('Common_ExportToXeroCSV')}</span>
							</MenuItem>}
						</DropdownButton>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'paymentHistoriesFilter' })(withTranslation()(Filter));